module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "members"
  }, [_c('div', {
    staticClass: "members__container"
  }, [_c('h2', [_vm._v("Members of")]), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below('474px')) ? _c('el-carousel', {
    attrs: {
      "arrow": "always",
      "height": "140px",
      "trigger": "click",
      "indicator-position": "none",
      "autoplay": true
    }
  }, _vm._l((Math.ceil(_vm.members.length / 2)), function(i) {
    return _c('el-carousel-item', {
      key: i,
      staticClass: "members__list"
    }, _vm._l((_vm.members.slice((i - 1) * 2, i * 2)), function(member) {
      return _c('members-item', {
        key: member.id,
        attrs: {
          "member": member
        }
      })
    }))
  })) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above('475px') && _vm.$mq.below('739px')) ? _c('el-carousel', {
    attrs: {
      "arrow": "always",
      "height": "140px",
      "trigger": "click",
      "indicator-position": "none",
      "autoplay": true
    }
  }, _vm._l((Math.ceil(_vm.members.length / 3)), function(i) {
    return _c('el-carousel-item', {
      key: i,
      staticClass: "members__list"
    }, _vm._l((_vm.members.slice((i - 1) * 3, i * 3)), function(member) {
      return _c('members-item', {
        key: member.id,
        attrs: {
          "member": member
        }
      })
    }))
  })) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above('740px') && _vm.$mq.below('1023px')) ? _c('el-carousel', {
    attrs: {
      "arrow": "always",
      "height": "140px",
      "trigger": "click",
      "indicator-position": "none",
      "autoplay": true
    }
  }, _vm._l((Math.ceil(_vm.members.length / 5)), function(i) {
    return _c('el-carousel-item', {
      key: i,
      staticClass: "members__list"
    }, _vm._l((_vm.members.slice((i - 1) * 5, i * 5)), function(member) {
      return _c('members-item', {
        key: member.id,
        attrs: {
          "member": member
        }
      })
    }))
  })) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above('1024px')) ? _c('div', {
    staticClass: "members__list"
  }, _vm._l((_vm.members), function(member) {
    return _c('members-item', {
      key: member.id,
      attrs: {
        "member": member
      }
    })
  })) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-143aaafc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pub/assets/js/vue/components/Members/List.vue
// module id = 72
// module chunks = 0